<template>
  <div class="volumec">
    <a class="vol-toggle" :class="{muted: value==0}" href="" v-on:click.prevent="toggleMute" v-on:mouseenter.self="showBar" v-on:mouseleave.self="hideBar"></a>
    <div class="vol-val" :class="{low: value<30, hi: value>=30, visible: visible}" v-on:mousedown.prevent="dragStart" ref="volVal" v-on:mouseenter.self="showBar" v-on:mouseleave.self="hideBar">
      <em :style="{width: value+'%'}"></em><span>{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data: ()=>({
    oldVolume: 0,
    startPoint: null,
    seekStart: null,
    newVolume: null,
    visible: false,
  }),
  watch: {
    value: {
      handler(newVal, oldVal) {
        this.oldVolume=oldVal==null?newVal:oldVal;
      },
      immediate: true,
    },
  },
  methods: {
    toggleMute() {
      if (this.value==0)
        this.$emit("input", this.oldVolume);
      else
        this.$emit("input", 0);
    },
    dragStart($event) {
      this.startPoint=$event;
      this.seekStart=this.value;
    },
    dragMove($event) {
      if (!this.startPoint)
        return;
      var movement=$event.clientX-this.startPoint.clientX;
      var innerWidth=this.$refs.volVal.clientWidth;
      var seekDiff=movement/innerWidth*100;
      this.newVolume=this.seekStart+seekDiff;
      this.newVolume=Math.round(Math.max(0, Math.min(100, this.newVolume)));
      this.$emit("input", this.newVolume);
    },
    dragEnd($event) {
      this.newVolume=null;
      this.seekStart=null;
      this.startPoint=null;
    },
    showBar($e) {
      this.visible=true;
      clearTimeout(this.hideBarTimeout);
    },
    hideBar($e) {
      clearTimeout(this.hideBarTimeout);
      this.hideBarTimeout=setTimeout(()=>{
        this.visible=false;
      }, 3000);
    },
  },
  mounted() {
    this.dragMoveHandler=($event)=>this.dragMove($event);
    document.addEventListener("mousemove", this.dragMoveHandler, true);
    this.dragEndHandler=($event)=>this.dragEnd($event);
    document.addEventListener("mouseup", this.dragEndHandler, true);
  },
  destroyed() {
    document.removeEventListener("mousemove", this.dragMoveHandler);
    document.removeEventListener("mouseup", this.dragEndHandler);
  },
};
</script>
